export default {
  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Shorts",
  "cat.headwear": "Gorras y sombreros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior",
  "cat.jersey": "Camisetas deportivas",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otros artículos",

  "cat.shoes.desc": "Zapatillas y calzado diario",
  "cat.hoodies.desc": "Sudaderas y sweats acogedores",
  "cat.tshirts.desc": "Camisetas casuales",
  "cat.jackets.desc": "Capas para días fríos",
  "cat.pants.desc": "Joggers, pantalones y shorts",
  "cat.headwear.desc": "Gorras, beanies y más",
  "cat.sets.desc": "Conjuntos de dos piezas",
  "cat.underwear.desc": "Básicos cómodos diarios",
  "cat.jersey.desc": "Camisetas deportivas de partido",
  "cat.accessories.desc": "Pequeños extras y gear",
  "cat.bags.desc": "Bolsos y mochilas",
  "cat.belts.desc": "Correas y cinturones",
  "cat.perfumes.desc": "Aromas frescos",
  "cat.other.desc": "Todo lo demás que aman los fans",

  "home.heroBadge": "Recurso independiente de merch para fans",
  "home.heroTitle": "US Fans Spreadsheet — Todas las categorías de merch para fans en un solo lugar",
  "home.heroSubtitle": "Explora zapatos, camisetas deportivas, sudaderas y más a través de un recurso limpio y organizado que te ayuda a encontrar tu gear favorito más rápido.",
  "home.heroCta1": "usfans spreadsheet",
  "home.heroCta2": "comprar ahora",
  "home.heroTrust": "Enlaces rápidos a categorías • Gear seleccionado • Actualizado con frecuencia",

  "home.dropdownTitle": "Explora las categorías de merch para fans",
  "home.dropdownSubtitle": "Elige una categoría en el menú para ir directamente a esa colección en nuestra tienda principal.",

  "home.categoriesTitle": "Explora cada categoría",
  "home.categoriesSubtitle": "Toca cualquier categoría para abrir su página de colección dedicada en la tienda principal.",

  "home.aboutTitle": "¿Qué es el US Fans Spreadsheet?",
  "home.aboutP1": "El US Fans Spreadsheet es un recurso organizado y fácil de navegar que reúne el merch para fans en categorías claramente etiquetadas. En lugar de buscar entre páginas dispersas, puedes ir directamente al gear que quieres: desde zapatos y camisetas deportivas hasta sudaderas, chaquetas, bolsos y accesorios.",
  "home.aboutP2": "Cada categoría enlaza directamente con una colección seleccionada en nuestra tienda principal, para que pierdas menos tiempo buscando y más tiempo encontrando piezas que encajen con tu estilo. Ya sea que busques unas zapatillas nuevas o un conjunto completo a juego, todo está a un clic.",
  "home.aboutB1": "Merch para fans organizado en un solo lugar limpio",
  "home.aboutB2": "Enlaces directos a cada categoría principal",
  "home.aboutB3": "Orientación fácil para principiantes",
  "home.aboutB4": "Colecciones actualizadas con frecuencia",

  "home.guideTitle": "Guía destacada",
  "home.guideSubtitle": "Descubre cómo funciona este recurso y cómo elegir el gear de fans adecuado.",
  "home.guideCategory": "Guía de compra",
  "home.guideCardTitle": "¿Qué es el US Fans Spreadsheet? Una guía completa",
  "home.guideCardDesc": "Aprende cómo funciona este recurso, qué categorías hay disponibles y cómo elegir el merch para fans correcto.",
  "home.guideRead": "Leer la guía",
  "home.guideTime": "6 min de lectura",
};